import {
  GET_CLIENT_FILES,
  GET_CLIENT_FILES_SUCCESS,
  GET_CLIENT_FILES_ERROR,
  UPLOAD_CLIENT_FILE,
  UPLOAD_CLIENT_FILE_SUCCESS,
  UPLOAD_CLIENT_FILE_ERROR,
  DELETE_CLIENT_FILE,
  DELETE_CLIENT_FILE_SUCCESS,
  DELETE_CLIENT_FILE_ERROR,
} from './constants';

export function getClientFiles(clientId) {
  return { type: GET_CLIENT_FILES, clientId };
}
export function getClientFilesSuccess(payload) {
  return { type: GET_CLIENT_FILES_SUCCESS, payload };
}
export function getClientFilesError(err) {
  return { type: GET_CLIENT_FILES_ERROR, err };
}

/**
 * `payload` shape: `{ clientId, fileName, mimeType, size, dataUrl, category }`
 */
export function uploadClientFile(payload) {
  return { type: UPLOAD_CLIENT_FILE, payload };
}
export function uploadClientFileSuccess(payload) {
  return { type: UPLOAD_CLIENT_FILE_SUCCESS, payload };
}
export function uploadClientFileError(err) {
  return { type: UPLOAD_CLIENT_FILE_ERROR, err };
}

export function deleteClientFile(fileId) {
  return { type: DELETE_CLIENT_FILE, fileId };
}
export function deleteClientFileSuccess(fileId) {
  return { type: DELETE_CLIENT_FILE_SUCCESS, fileId };
}
export function deleteClientFileError(err) {
  return { type: DELETE_CLIENT_FILE_ERROR, err };
}
